import { ReactNode } from "react";

export default function ActionsColumn({ children }: { children?: ReactNode }) {
  if (!children) return <div className={width} />;

  return (
    <div
      className={`${width} h-full flex flex-col justify-between items-center p-1 bg-slate-50 rounded-tr-sm rounded-br-sm`}
    >
      {children}
    </div>
  );
}

const width = "min-w-[18px] max-w-[18px]";
